import type { WiwState } from '@/store';

export const getWizardCompletedOnce = (state: WiwState): boolean =>
  state.reporting.customReportBuilder.wizardCompletedOnce;
